export const formatPercentage = (value) => {
  const numericValue = typeof value === 'number' ? value : parseFloat(value);
  if (Number.isNaN(numericValue)) {
    return '0.00%';
  }
  return `${numericValue.toFixed(2)}%`;
};

// PROGRESS TOTAL (penyelesaian kumulatif) HARUS berasal dari completedQuantity / quantity —
// sumber kebenaran yang sama dengan dashboard lama & laporan. JANGAN jumlahkan persentase
// volume submission per periode (progressBefore + progressThisWeek): nilai itu hanya
// menghitung submission yang sudah di-approve & berbasis volume mingguan, sehingga pekerjaan
// yang sudah selesai bisa terbaca 99.xx% (atau >100%). Urutan sumber: field backend
// progressTotalPercentage → completedQuantity/quantity → fallback legacy periode.
export const computeTotalProgressPercent = (row) => {
  if (!row) return 0;
  const clamp = (v) => Math.min(100, Math.max(0, v));

  const backend = parseFloat(row.progressTotalPercentage);
  if (Number.isFinite(backend)) return clamp(backend);

  const quantity = parseFloat(row.quantity);
  const completed = parseFloat(
    row.quantityCompleted != null ? row.quantityCompleted : row.completedQuantity
  );
  if (Number.isFinite(quantity) && quantity > 0 && Number.isFinite(completed)) {
    return clamp((completed / quantity) * 100);
  }

  const before = parseFloat(row.progressBeforeThisWeekPercentage) || 0;
  const thisWeek = parseFloat(row.progressThisWeekPercentage) || 0;
  return clamp(before + thisWeek);
};

export const getProgressChipColor = (value) => {
  if (value >= 80) return 'success';
  if (value >= 50) return 'warning';
  if (value > 0) return 'error';
  return 'default';
};

export const extractRomanNumeral = (str) => {
  const match = str.match(/^(IX|IV|V?I{0,3}|X{0,3})/);
  if (!match) return 0;
  const roman = match[1];
  const romanNumerals = {
    'I': 1,
    'II': 2,
    'III': 3,
    'IV': 4,
    'V': 5,
    'VI': 6,
    'VII': 7,
    'VIII': 8,
    'IX': 9,
    'X': 10
  };
  return romanNumerals[roman] || 0;
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const formatDateLong = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

export const formatCurrency = (value) => {
  const numericValue = Number(value) || 0;
  return numericValue.toLocaleString('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
};

export const getProgressColor = (progress, target) => {
  const diff = progress - target;
  
  if (diff >= 0) return '#4CAF50'; // On track or ahead
  if (diff >= -5) return '#FF9800'; // Slightly behind
  return '#F44336'; // Significantly behind
};

export const getDeadlineStatus = (daysRemaining, progress) => {
  if (daysRemaining < 0) {
    return { 
      status: 'Overdue', 
      color: '#F44336',
      iconName: 'Error'
    };
  }
  
  if (daysRemaining <= 3 && progress < 90) {
    return { 
      status: 'At Risk', 
      color: '#FF9800',
      iconName: 'Warning'
    };
  }
  
  if (progress >= 90) {
    return { 
      status: 'Almost Done', 
      color: '#4CAF50',
      iconName: 'CheckCircle'
    };
  }
  
  return { 
    status: `in ${daysRemaining} days`, 
    color: '#2196F3',
    iconName: 'Calendar'
  };
};

export const getDaysRemaining = (dateString) => {
  if (!dateString) return 0;
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const dueDate = new Date(dateString);
  dueDate.setHours(0, 0, 0, 0);
  
  const diffTime = dueDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays;
};

export const statusColors = {
  'in_progress': '#2196F3',
  'planning': '#FF9800', 
  'on_hold': '#9E9E9E',
  'completed': '#4CAF50',
  'cancelled': '#F44336',
  'unknown': '#757575'
};
